module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItemSelected"
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v(_vm._s(_vm.newsItem.title))]), _vm._v(" "), (_vm.newsItem.images.length > 0) ? _c('carousel', {
    attrs: {
      "autoplay": true,
      "perPage": 1,
      "navigationEnabled": true,
      "loop": true,
      "align": "center"
    }
  }, _vm._l((_vm.newsItem.images), function(image) {
    return _c('slide', {
      key: image.id
    }, [_c('img', {
      staticClass: "sliderImg",
      attrs: {
        "src": _vm.multimediaBase + image.imagePath,
        "alt": image.name,
        "width": "350px",
        "height": "150px"
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "newsInfo"
  }, [_c('i', [_vm._v(_vm._s(_vm.newsItem.dateStr))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "newsDetail",
    domProps: {
      "innerHTML": _vm._s(_vm.newsItem.description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.news
    }
  }, [_vm._v("Regresar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7e024a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsDetailComponent.vue
// module id = 79
// module chunks = 0